<template>
  <div>
    <div class="header-search">
      <van-search v-model="value1" @search="onSearch" placeholder="请输入产品名称">
        <template #left-icon>
          <svg-icon @click.prevent="onSearch" icon-class="home_search"></svg-icon>
        </template>
      </van-search>
      <!-- <div class="header-search-img">
        <svg-icon icon-class="home_info"></svg-icon>
      </div> -->
    </div>
    <div class="product-swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in swipeImg1" :key="index">
          <!-- <svg-icon :icon-class="item.img"></svg-icon> -->
          <img :src="item.img" alt />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="product-list">
      <ul class="product-nav">
        <li
          v-for="(item,index) in liList"
          :key="index"
          :class="isLink==item.id ? 'li-style li-check-style' : 'li-style'"
          @click="chooseLi(item,index)"
        >
          {{item.name}}
          <svg-icon v-if="isLink==item.id" icon-class="home_line2"></svg-icon>
        </li>
      </ul>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="pro-list-list" v-for="(item,index) in newDataList" :key="index">
            <div v-if="level=='热门'">
              <div class="product-type-title">{{item.name}}</div>
              <div v-if="item.name=='银行'">
                <div
                  class="bank-list"
                  v-for="(c,i) in item.list"
                  :key="i"
                  @click.prevent="checkData(c)"
                >
                  <div class="list-com bank-top">
                    <div class="bank-top-left">
                      <div class="bank-top-left-img">
                        <img :src="c.thumbnail" alt />
                      </div>
                    </div>
                    <div class="bank-top-right">
                      <p class="product-list-title">{{c.name}}</p>
                      <p class="product-list-summary">手续简单抵押率高</p>
                    </div>
                  </div>
                  <div class="list-com bank-bottom">
                    <p v-html="c.digest"></p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="bank-list product-safe"
                  v-for="(t,ii) in item.list"
                  :key="ii"
                  @click.prevent="checkData(t)"
                >
                  <div class="product-safe-left">
                    <img :src="t.thumbnail" alt />
                  </div>
                  <div class="product-safe-right">
                    <div>
                      <p class="product-list-title">{{t.name}}</p>
                      <div class="safe-right-height">
                        <p v-html="t.digest" class="product-list-summary"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="product-type-title">{{item.name}}</div>
              <div v-if="level=='银行'">
                <div
                  class="bank-list"
                  v-for="(tt,ind) in item.list"
                  :key="ind"
                  @click.prevent="checkData(tt)"
                >
                  <div class="list-com bank-top">
                    <div class="bank-top-left">
                      <div class="bank-top-left-img">
                        <img :src="tt.thumbnail" alt />
                      </div>
                    </div>
                    <div class="bank-top-right">
                      <p class="product-list-title top-title">{{tt.name}}</p>
                      <p class="product-list-summary top-summary">手续简单抵押率高</p>
                    </div>
                  </div>
                  <div class="list-com bank-bottom">
                    <p v-html="tt.digest"></p>
                  </div>
                </div>
              </div>
              <div v-if="level!='银行'">
                <div
                  class="bank-list product-safe"
                  v-for="(yy,o) in item.list"
                  :key="o"
                  @click.prevent="checkData(yy)"
                >
                  <div class="product-safe-left">
                    <img :src="yy.thumbnail" alt />
                  </div>
                  <div class="product-safe-right">
                    <div>
                      <p class="product-list-title">{{yy.name}}</p>
                      <div class="safe-right-height">
                        <p v-html="yy.digest" class="product-list-summary"></p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-dialog v-model="show" confirmButtonText='去绑卡' title="请先绑定银行卡，以便于使用鲨云积分购买产品。" cancelButtonText='知道了' show-cancel-button @cancel='oncancel' @confirm='onConfirm'>
    </van-dialog>
  </div>
</template>

<script>
import URL from '@/api/api'
import {setLocal, setSession, UrlSearch} from "@/utils/utils";

export default {
  data() {
    return {
      value1: '',
      isLink: '',
      level: '热门',
      active: '热门',
      loading: false,//加载中
      finished: false,//是否已加载完成
      refreshing: false,//下拉刷新
      productList: [],
      newDataList: [],
      productListShow: [],
      value: this.$route.query.value,
      search: '',
      swipeImg1: [
        { img: require('./../view/product/img/product_banner.png') },
      ],
      liList: [],
      page: 1,//当前页数
      size: 12,//每页数量
      total: 0,
      show:false,//绑卡弹框
    }
  },
  mounted() {
    if(UrlSearch().level){
      this.isLink=11
    }
    this.getProductType()
    // this.getData()
    if(UrlSearch().productid){
      setSession('product_id',UrlSearch().productid)
      setSession('agent_PhoneNo',UrlSearch().agentPhoneNo)
    }
    if (localStorage.getItem('openid')) {
      this.checkIsLoginAndAuth(localStorage.getItem('openid'))
    }
  },

  methods: {
    //弹窗确定绑定银行卡
    onConfirm(){
      this.$router.push({ path: '/sasabank', query: { appCode: UrlSearch().appCode, userKey: UrlSearch().userKey} });
    },
    //弹窗取消绑定银行卡
    oncancel(){
      setSession('bindingCard',1)
    },
    getProductType() {
      this.$fetchGet(URL.ProductType.url).then(res => {
        // this.liList=res.data.data
        let list = res.data.data
        list.unshift({ id: '', name: '热门' })
        this.liList = list
      })
    },
    onRefresh() {
      let that = this
      // console.log(this.refreshing);
      that.finished = false;
      that.page = 1
      that.loading = true;
      that.getData();
    },
    onLoad() {
      this.getData();
    },
    getData() {
      let that = this
      let data = {
        idProductType: that.isLink,
        param: that.value1,
        page: that.page,
        size: that.size,
        createrCode: 'ZFKJ'
      }
      that.$fetchGet(URL.ProductTypeList.url, data).then(res => {
        that.refreshing = false;
        that.loading = false;
        that.total = res.data.data.total;
        let list = res.data.data.records;
        let bxList = []
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          that.newDataList = []
          return;
        }
        // 将新数据与老数据进行合并
        if (that.page > 1) {
          that.productList = [...that.productList, ...list]
        } else {
          that.productList = list
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.productList.length >= that.total) {
          that.finished = true;
        }
        //说明可能还有下一页
        if (that.productList.length < that.total) {
          that.page++;
        }

        that.productList.map((item, index, x) => {
          if (item.idProductType == 11) {
            let data1 = {
              name: '保险',
              list: x.filter(y => y.idProductType == 11) || []
            }
            bxList.push(data1)
            // console.log(x);
          } else if (item.idProductType == 14) {
            let data = {
              name: '教育',
              list: x.filter(y => y.idProductType == 14) || []
            }
            bxList.push(data)
          } else if (item.idProductType == 13) {
            let data = {
              name: '银行',
              list: x.filter(y => y.idProductType == 13) || []
            }
            bxList.push(data)
          } else if (item.idProductType == 15) {
            let data = {
              name: '证券',
              list: x.filter(y => y.idProductType == 15) || []
            }
            bxList.push(data)
          }
        })
        that.newDataList = that.delRemoval(bxList)
      })
    },
    delRemoval(arr2) {
      var temp = [];
      arr2.forEach(function (a) {
        var check = temp.every(function (b) {
          return a.name !== b.name;
        })
        check ? temp.push(a) : ''
      })
      return temp;
    },
    chooseLi(item, i) {
      this.isLink = item.id
      this.level = item.name
      this.page = 1
      this.finished = false
      this.getData()
    },
    checkData(ctem) {
      if (localStorage.getItem("phoneNoC")) {
        //有手机号 = 登录过
        if (localStorage.getItem("authFlagC") || ctem.realName==1) {
          //1认证过  0 未认证
          if (ctem.companyCode=='qixin') {
            this.$fetchPost(URL.qixinProdUrl.url, this.$toFormData({ 'spuId': ctem.spuId , userId:localStorage.getItem("userid") })).then(res => {
              if (res.data.code==20000) {
                this.$router.push({
                  path: '/isLink',
                  query: { linkUrl: res.data, name: ctem.name, type: 1 },
                  replace: true
                });
              }
            })
          }
          if (ctem.externalLink!=null&&ctem.externalLink.length > 0) {
            //  window.location.href = ctem.externalLink
            this.$router.push({
              path: '/isLink',
              query: { linkUrl: ctem.externalLink, name: ctem.name, type: 1 },
              replace: true
            });
          } else {
            this.$router.push({ path: '/productDetails/details', query: { id: ctem.id } });
          }
        } else {
          // 跳认证页面
          this.$router.push({ path: '/identityCheck' })
        }
      }
       else {
        //跳登录页面
        this.$router.push({ path: '/login' })
      }
    },
    onSearch() {
      let that = this
      // console.log(this.refreshing);
      that.finished = false;
      that.page = 1
      that.loading = true;
      that.getData()
    },
    getProduct() {
      this.getTraceSave()
      let linkId = sessionStorage.getItem('product_id')
      // console.log(this.linkId);
      this.$fetchGet(URL.productDetails.url, { id: linkId }).then(res => {
        console.log(res);
        if (res.data.code == 20000) {
          window.location.href = res.data.data.externalLink
        }
      })
    },
    judgeBlank(value){
      if (value != null && value != '' && value != undefined && value != 'undefined') {
        return value;
      }else {
        return '';
      }
    },
    checkIsLoginAndAuth(openid) {
      const  appCode = this.judgeBlank(UrlSearch().appCode)
      const  userKey = this.judgeBlank(UrlSearch().userKey)
      this.$fetchPost(URL.getBindingInfo.url, this.$toFormData({ 'openid': openid,appCode: appCode, userKey: userKey })).then(res => {
        if (res.data.code == 20000) {
          if(res.data.data.bindingCardFlag=='0' && res.data.data.tag=='sasago'){
            this.show=true
            if(sessionStorage.getItem('bindingCard')==1){
              this.show=false
            }
          }else{
            this.show=false
          }
          let phoneNo = res.data.data.phoneNo;
          this.phoneNo = phoneNo
          let authFlag = res.data.data.authFlag;
          let realName = res.data.data.realName;
          setLocal('phoneNoC', phoneNo);
          setLocal("authFlagC", authFlag);
          setLocal("realNameC", realName);
          setLocal("cip", res.data.data.ip);
          let linkId = sessionStorage.getItem('product_id')
          if(linkId){
            this.getProduct()
          }
        } else {
          let linkId = sessionStorage.getItem('product_id')
          console.log(linkId);
          if (linkId) {
            this.getTraceSave()
            if (res.data.data.phoneNo) {
              this.getProduct()
            } else {
              this.$fetchGet(URL.productDetails.url, { id: this.linkId }).then(res => {
                if (res.data.code == 20000) {
                  window.location.href = res.data.data.externalLink
                }
              })
              // this.$router.push({ path: '/login', query: { linkId: linkId } })
            }
          }
        }
        let nickName = res.data.data.nickName;
        let headImg = res.data.data.headImg;
        setLocal("nickNameC", nickName);
        setLocal("headImgC", headImg);
      })
    },
    getTraceSave() {
      let data = {
        agentPhoneNo: sessionStorage.getItem('agent_PhoneNo'),
        openid: localStorage.getItem('openidC'),
        phoneNo: this.phoneNo,
        productId: sessionStorage.getItem('product_id')
      }
      this.$fetchPost(URL.traceSave.url, data).then(res => {
        console.log(res);
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-dialog{
    .van-dialog__header{
      padding: 20px;
    }
  }
.header-search {
  width: 355px;
  height: 26.5px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  // .svg-icon {
  //   width: 21.73px;
  //   height: 20.5px;
  // }
  // .header-search-img {
  //   margin-left: 10px;
  //   line-height: 26.5px;
  // }
    .van-search {
    width: 355px;
    padding: 0;
    border-radius: 5px;
    .van-search__content {
      padding: 0;
      line-height: 26.5px;
    }
    .van-cell {
      padding: 0;
      border: 0.5px solid #ff6c00;
      border-radius: 5px;
    }
    .svg-icon {
      width: 14.24px;
      height: 14.24px;
      padding-left: 5px;
    }
  }
}
.product-swipe {
  width: 355px;
  margin: 11px auto 0 auto;
  img {
    width: 355px;
    height: 80px;
  }
}
.product-list {
  width: 375px;
  margin-bottom: 32.5px;
  p {
    font-family: PingFang SC;
    color: #333333;
  }
  .product-list-title {
    max-height: 40px;
    margin: 12px 0 8px 18px;
    font-size: 14px;
    font-weight: Bold;
  }
  .product-list-summary {
    margin-left: 18px;
    font-size: 10.5px;
    font-weight: Regular;
  }
  .product-common-title {
    margin-top: 22px;
  }
  .product-nav {
    width: 375px;
    height: 48.5px;
    align-items: center;
    display: flex;
    justify-content: space-around;
    margin-top: 12.5px;
    background: url("./../view/product/img/product_bg.png") no-repeat 100%;
    background-size: 100%;
    .svg-icon {
      width: 13.5px;
      height: 2px;
      display: block;
      //   margin-left: 5.5px;
      //   margin-top: 2.5px;
      margin: 2.5px auto 0 auto;
    }
    .li-style {
      //   width: 28.5px;
      font-size: 14px;
      font-family: PingFang SC;
      color: #333333;
      font-weight: lighter;
    }
    .li-check-style {
      font-weight: Regular;
      color: #fc6e09;
    }
  }
  .pro-list-list {
    width: 355px;
    margin: 15.5px auto 0 auto;
    .product-type-title {
      margin-left: 10px;
      font-size: 16px;
      font-weight: Bold;
      color: #333333;
    }
    .bank-list {
      width: 355px;
      //   height: 153.5px;
      margin-top: 15.5px;
      padding: 10.5px 0 9.5px 0;
      background: #ffffff;
      border-radius: 10px;
      //   background: url('./img/product_bg1.png') no-repeat 100%;
      //   background-size: 100% 100% ;
      .list-com {
        width: 335px;
        margin: auto;
      }
      .bank-top,
      .bank-top-left {
        height: 65px;
        display: flex;
        .bank-top-left-img {
          width: 128px;
          height: 65px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .bank-top {
        // justify-content: space-between;
        align-items: center;
      }
      .bank-top-right {
        .top-title{
          height: 20px;
          overflow: hidden;
        }
        .top-summary{
          height: 15px;
          overflow: hidden;
        }
        .svg-icon {
          width: 62px;
          height: 24.5px;
        }
      }
      .bank-bottom {
        height: 56.5px;
        margin-top: 12px;
        line-height: 1.5;
        overflow: hidden;
        p {
          height: 14px;
          padding-left: 17.5px;
          font-size: 10px;
        }
      }
    }
    .product-safe {
      height: 135px;
      padding: 0;
      align-items: center;
      display: flex;
      .product-safe-left {
        width: 128px;
        height: 110px;
        margin-left: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .product-safe-right {
        // border: 1px solid;
        width: 195.5px;
        height: 110px;
        margin-left: 11.5px;
        .safe-right-height {
          height: 48px;
          overflow: hidden;
        }
        .product-list-summary {
          margin-left: 0;
          height: 14px;
        }
        .product-list-title {
          margin: 10px 0 5px 6.5px;
        }
      }
    }
  }
}
</style>
